import React, { useEffect, useRef, useState } from "react";
import config from '../../config';
import { headers } from "../../token";
import axios from "axios";
import { Link, useSearchParams } from "react-router-dom";
import ModifyComment from "../qrjobviews2/ModifyComment";
import vAdminformat from '../../adminFormat';
import QRUpdateJobs from "../qrjobviews2/QRJobUpdate";
import STLViewer from "../Canvas/STLViewer";
import QRCode from "react-qr-code";
import { useReactToPrint } from 'react-to-print';

import SimpleSTLViewerToImage from "../Canvas/SimpleStlViewsImage";
import Swal from "sweetalert2";
import AddLiveJobComment from "./AddLiveJobComment";
import getFileExtension from "../getFileExtension";


const server_backend = config.API_URL;
const server_frontend = config.FrondEndURL;

const QRJobViewOnlyJob = ({ onRenderComplete, qr }) => {

    const [Job, setJob] = useState([]);
    const [trackingView, setTrackingView] = useState([]);
    const [isComment, setIsComment] = useState(false);
    const [isModifiyComment, setIsModifyComment] = useState(false);
    const [onCommentID, setOnCommentID] = useState(0);
    const [isUpdating, setIsUpdating] = useState(false);
    const [loading, setLoading] = useState(false);
    const [fileURL, setFileURL] = useState(null);
    const [statusJob, setStatusJob] = useState([]);
    const [showPrintableDiv, setShowPrintableDiv] = useState(false);
    const [currentDateTime, setCurrentDateTime] = useState('');

    const [order, setOrder] = useState([]);
    const [searchParams] = useSearchParams();
    const dropdownRef = useRef(null);
    const [OrderID, setOrderID] = useState(null);
    const [direction, setDirection] = useState("");

    const [selectedOption, setSelectedOption] = useState(null);
    const [productList, setProductList] = useState([]);
    const [modalItem, setModalItem] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [invoiceStatus, setInvoiceStatus] = useState("DRAFT");
    const statusOptions = [
        { label: "Draft", value: "DRAFT", color: "#ffc107" },
        { label: "Submitted", value: "SUBMITTED", color: "#17a2b8" },
        { label: "Authorised", value: "AUTHORISED", color: "#28a745" },
    ];

    const handleFormChange = (newStatus) => {
        if (newStatus > order.status_common) {
            setDirection("slide-left");
        } else {
            setDirection("slide-right");
        }

        setTimeout(() => {
            //Update the form of formdata
            setDirection(""); //Reset the animation
        }, 100); //must coincide with the duration of animation
    };

    const [formData, setFormData] = useState({
        accessToken: localStorage.getItem('xeroAccessToken') || '',
        tenantId: localStorage.getItem('xeroTenantId') || '',
    });

    useEffect(() => {
        const getCurrentOrder = async () => {
            setLoading(true)
            try {
                const response = await axios.get(`${server_backend}/jobs/manual/view?qr=${qr}`, headers);
                //const response = await axios.get(`${server_backend}/Orders/select?id=${OrderID}`, headers);
                if (response.data.RES_CODE === "00") {

                    const data = (response.data.RES_RESULT);
                    console.log("Unexpected error, please check")
                    setCurrentDateTime(data.date_estimated);
                    setOrderID(data.job_ID);
                    setOrder(data);
                    setFileURL(`${server_backend}/${data.files_path_file}`);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            } finally {
                setLoading(false)
                onRenderComplete && onRenderComplete()
            }
        }
        getCurrentOrder();
    }, []);


    useEffect(() => {
        const getStatusJob = async () => {
            try {
                const response = await axios.get(`${server_backend}/system/transactions/status/Job`, headers);
                console.log("Unexpected error, please check")
                if (response.data.RES_CODE === "00") {
                    setStatusJob(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getStatusJob();
    }, []);

    useEffect(() => {
        const getProduct = async () => {
            try {
                const response = await axios.get(`${server_backend}/Products/list`, headers);

                if (response.data.RES_CODE === "00") {

                    const productsWithSelection = response.data.RES_RESULT.map(product => ({
                        ...product,
                        isSelected: true,
                    }));

                    setProductList(productsWithSelection);
                    setSelectedProducts(productsWithSelection); //inicialize selected products
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        };
        getProduct();
    }, []);


    useEffect(() => {
        //Select the element with ID "Page-Topbar"
        const topbar = document.getElementById('page-topbar');
        const page = document.getElementById('page-content');

        //Verify if the element exists and hide it
        if (topbar && page) {
            topbar.style.display = 'none'; //Hides the Topbar
            page.className = ''
        }


        return () => {
            if (topbar) {
                topbar.style.display = '';
            }
        };
    }, []);


    const getCurrentOrder = async () => {

        setLoading(true)

        try {
            const response = await axios.get(`${server_backend}/jobs/manual/view?qr=${qr}`, headers);

            if (response.data.RES_CODE === "00") {
                const data = response.data.RES_RESULT;
                //console.log("Unexpected error, please check")
                //Clean the modal and ensure that "items" is always present
                //SetSeldtedorder (Data);
                setOrder(data);
                setFileURL(`${server_backend}/${data.files_path_file}`);
                setSelectedOption('yes');

            }
        } catch (error) {
            console.log("Unexpected error, please check")
        } finally {
            setLoading(false)
            onRenderComplete && onRenderComplete()
        }
    }

    const getTrackingData = async () => {
        try {
            const response = await axios.get(`${server_backend}/Jobs/tracking/list?id=${OrderID}`, headers);
            if (response.data.RES_CODE === "00") {
                //console.log("Unexpected error, please check")
                const data = (response.data.RES_RESULT);
                setTrackingView(data)
            }
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    }

    const CloseAddCommentModal = () => {
        setIsComment(false)
    }

    const showAddCommentModal = () => {
        setIsComment(true)
    }

    const showModifyCommentModal = () => {
        setIsModifyComment(true)
    }

    const CloseModifyCommentModal = () => {
        setIsModifyComment(false)
    }

    const ShowModalUpdate = () => {
        setIsUpdating(true);
    }

    const CloseModalUpdate = () => {
        setIsUpdating(false);
    }

    const currentStep = statusJob.find((status) => status.est_ID === Job.est_ID)?.est_ID || 0;

    const componentRef = useRef();


    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "Material Information",
        onAfterPrint: () => setShowPrintableDiv(false),

    });


    const [imageURL, setImageURL] = useState(null);

    useEffect(() => {
        const loadImage = async () => {
            try {
                const image = await SimpleSTLViewerToImage(fileURL);

                setImageURL(image);
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        };

        if (fileURL) {
            loadImage();
        }
    }, [fileURL]);



    const handleUpdate = async (estID) => {

        setLoading(true);

        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to save this transaction?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {

                try {
                    const response = await axios.post(`${server_backend}/jobs/manual/scan_point`, {
                        id: OrderID,
                        point: estID
                    }, headers);
                    //console.log("Unexpected error, please check")
                    if (response.data.RES_CODE === "00") {
                        /* Swal.fire({
                              icon: 'success',
                              title: 'Updated Successfully',
                              showConfirmButton: false,
                              timer: 2000
                          }); */

                        handleFormChange(estID);

                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error updating Order',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                } catch (error) {
                    const responseData = error.response.data.RES_MESSAGE;
                    //console.log("Unexpected error, please check")
                    Swal.fire({
                        icon: 'error',
                        title: responseData,
                        showConfirmButton: false,
                        timer: 3000
                    });
                } finally {
                    getCurrentOrder();
                    setLoading(false);
                }
            }
        }
        )
    };

    const changeGroupCollective = async (estID) => {

        setLoading(true);

        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to save this transaction?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {

                try {
                    const response = await axios.post(`${server_backend}/jobs/manual/collective_all`, {
                        job_id: OrderID,
                        est_id: estID
                    }, headers);


                    if (response.data.RES_CODE === "00") {

                        handleFormChange(estID);

                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error updating Order',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error updating Order',
                        showConfirmButton: false,
                        timer: 2000
                    });

                } finally {
                    getCurrentOrder();
                    setLoading(false);
                }
            }
        }
        )
    };

    const changePriority = async (priority) => {

        if (priority === order.priority) {
            return;
        }

        try {

            const response = await axios.post(`${server_backend}/jobs/manual/priority`, {
                id: OrderID,
                priority: priority
            }, headers);
            //console.log("Unexpected error, please check")
            if (response.data.RES_CODE === "00") {
                /*Swal.fire({
                     icon: 'success',
                     title: 'Updated Successfully',
                     showConfirmButton: false,
                     timer: 2000
                 }); */

            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error updating Order',
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        } catch (error) {
            const responseData = error.response.data.RES_MESSAGE;
            console.log("Unexpected error, please check")
            Swal.fire({
                icon: 'error',
                title: responseData,
                showConfirmButton: false,
                timer: 3000
            });
        } finally {
            getCurrentOrder()
        }

    };

    const handleSelectQuantity = async (job, quantity) => {
        //setCurrentJobQty(quantity);
        //console.log("Unexpected error, please check")

        try {

            const response = await axios.post(`${server_backend}/jobs/manual/point`, {
                id: OrderID,
                ord_id: job.ord_ID,
                point: order.point,
                qty: quantity,
                confirm: order.point === 1 ? job.sp1_pass : (order.point === 2 ? job.sp2_pass : (order.point === 3 ? job.sp3_pass : (order.point === 4 ? job.sp4_pass : 0))),
            }, headers);

            if (response.data.RES_CODE === "00") {
                /* Swal.fire({
                      icon: 'success',
                      title: 'Updated Successfully',
                      showConfirmButton: false,
                      timer: 2000
                  }); */

            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error updating Order',
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        } catch (error) {
            const responseData = error.response.data.RES_MESSAGE;
            //console.log("Unexpected error, please check")
            Swal.fire({
                icon: 'error',
                title: responseData,
                showConfirmButton: false,
                timer: 3000
            });
        } finally {
            getCurrentOrder()
        }
        //Close the dropdown manually1
        if (dropdownRef.current) {
            dropdownRef.current.classList.remove('show');
            dropdownRef.current.previousSibling.classList.remove('show');
        }
    };

    const handleChangePass = async (job, confirm) => {

        try {

            //console.log({ jobID: job.ordj_ID, order: OrderID, point: order.point, qty: order.point === 1 ? job.sp1_qty : (order.point === 2 ? job.sp2_qty : (order.point === 3 ? job.sp3_qty : (order.point === 4 ? job.sp4_qty : 0))), confirm: confirm });

            if (order.point === 1) {
                if (job.sp1_pass === confirm) {
                    return;
                }
            } else if (order.point === 2) {
                if (job.sp2_pass === confirm) {
                    return;
                }
            } else if (order.point === 3) {
                if (job.sp3_pass === confirm) {
                    return;
                }
            } else if (order.point === 4) {
                if (job.sp4_pass === confirm) {
                    return;
                }
            }

            const response = await axios.post(`${server_backend}/jobs/manual/point`, {
                id: OrderID,
                ord_id: job.ordj_ID,
                point: order.point,
                qty: order.point === 1 ? job.sp1_qty : (order.point === 2 ? job.sp2_qty : (order.point === 3 ? job.sp3_qty : (order.point === 4 ? job.sp4_qty : 0))),
                confirm: confirm
            }, headers);

            if (response.data.RES_CODE === "00") {
                /*Swal.fire({
                     icon: 'success',
                     title: 'Updated Successfully',
                     showConfirmButton: false,
                     timer: 2000
                 }); */



            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error updating Order',
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        } catch (error) {
            const responseData = error.response.data.RES_MESSAGE;
            //console.log("Unexpected error, please check")
            Swal.fire({
                icon: 'error',
                title: responseData,
                showConfirmButton: false,
                timer: 3000
            });
        } finally {
            getCurrentOrder()
        }
    }

    const createInvoiceXero = async () => {


        const Products = [
            {
                comment: order.materials_comment || "ITEM001",
                name: order.materials_name,
                qty: order.qty,
                price: order.price,
                discount: order.discount || 0
            },
            ...selectedProducts
        ];

        //console.log("Unexpected error, please check")

        try {
            const lineItems = Products.map((product) => ({
                itemCode: product.comment || "ITEM001",
                description: product.name,
                quantity: product.qty,
                unitAmount: product.price,
                accountCode: '400',
                TaxType: "TAX001",
                unitTaxAmount: (product.price * 0.20) / product.qty,
                discountRate: product.discount || 0
            }));

            const currentDate = new Date();
            const currentDateInMillis = currentDate.getTime();

            const invoiceData = {
                type: "ACCREC",
                contact: {
                    name: `${order.fullname}`,
                    accountNumber: `${order.fullname}`,
                    emailAddress: `${order.email || "example@gmail.com"}`
                },
                CurrencyCode: "GBP",
                date: `/Date(${currentDateInMillis}+0000)/`,
                dueDate: `/Date(${currentDateInMillis + 7 * 24 * 60 * 60 * 1000}+0000)/`,
                dateString: currentDate.toISOString(),
                dueDateString: new Date(currentDate.setDate(currentDate.getDate() + 7)).toISOString(),
                lineAmountTypes: "Exclusive",
                status: invoiceStatus,
                lineItems: lineItems
            };

            const response = await axios.post(`${server_backend}/api/xero/invoice`, { invoiceData }, headers);

            closeModalItem()

            Swal.fire({
                icon: 'success',
                title: 'Invoice sent successfully',
                showConfirmButton: false,
                timer: 1000,
            });
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'An unexpected error has occurred, please try again later.',
                showConfirmButton: false,
                timer: 2000,
            });
        }
    };

    const openModalItem = () => {
        setModalItem(true);
    }

    const closeModalItem = () => {
        setModalItem(false);
    }

    const handleCheckboxChange = (product) => {
        setProductList((prevList) =>
            prevList.map((item) =>
                item.pto_ID === product.pto_ID
                    ? { ...item, isSelected: !item.isSelected }
                    : item
            )
        );

        setSelectedProducts((prevSelected) => {
            const isAlreadySelected = prevSelected.some((p) => p.pto_ID === product.pto_ID);
            if (isAlreadySelected) {
                return prevSelected.filter((p) => p.pto_ID !== product.pto_ID);
            } else {
                return [...prevSelected, { ...product }];
            }
        });
    };

    const handleQuantityChange = (id, newQty) => {
        setProductList((prevList) =>
            prevList.map((item) =>
                item.pto_ID === id ? { ...item, qty: newQty } : item
            )
        );

        setSelectedProducts((prevSelected) =>
            prevSelected.map((product) =>
                product.pto_ID === id ? { ...product, qty: newQty } : product
            )
        );
    };

    const handlePriceChange = (id, newPrice) => {
        setProductList((prevList) =>
            prevList.map((item) =>
                item.pto_ID === id ? { ...item, price: newPrice } : item
            )
        );

        setSelectedProducts((prevSelected) =>
            prevSelected.map((product) =>
                product.pto_ID === id ? { ...product, price: newPrice } : product
            )
        );
    };


    return (
        <div className="page-content" id="page-content">
            <div className="container-fluid">

                {/*start page title */}
                {isUpdating ? (
                    <QRUpdateJobs CloseViewJob={CloseModalUpdate} JobID={OrderID} getCurrentJob={getCurrentOrder} />
                ) : (
                    <div
                        className={`form-container ${direction}`}
                        style={{ position: "relative", overflow: "hidden" }}
                    >
                        <div className="row justify-content-center">
                            <div className="col-12 card">
                                <div className="card-header">
                                    <div className="d-flex justify-content-between align-items-center mt-3 p-2">

                                    </div>
                                    <div className="mb-4">
                                        <center>
                                            <div className="col-12">
                                                <div className="row">
                                                    <div className="col-6">
                                                        {order.barcode && (
                                                            <>
                                                                <QRCode
                                                                    size={25}
                                                                    style={{ height: "auto", width: "15vh" }}
                                                                    value={`${server_frontend}/jobs/qr-single-job?qr=${order.barcode}`}
                                                                    viewBox="0 0 256 256"
                                                                />
                                                                <label class="form-label">Single QR</label>
                                                            </>
                                                        )}
                                                    </div>
                                                    <div className="col-6">
                                                        {order.colle_id > 0 ? (
                                                            <div style={{ marginRight: "15px", textAlign: "center" }}>

                                                                <QRCode
                                                                    size={25}
                                                                    style={{ height: "auto", width: "15vh" }}
                                                                    value={`${server_frontend}/jobs/collective/qr-group?group=${order.colle_id}`}
                                                                    viewBox="0 0 256 256"
                                                                />
                                                                <label className="form-label">Collective QR</label>
                                                            </div>
                                                        ) : (
                                                            <div style={{ marginRight: "15px", textAlign: "center" }}>

                                                                <div
                                                                    style={{
                                                                        height: "15vh",
                                                                        width: "15vh",
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        border: "2px solid #ccc",
                                                                        fontSize: "10px",
                                                                        color: "#666",
                                                                        textAlign: "center",
                                                                        padding: "5px",
                                                                    }}
                                                                >
                                                                    No assigned <br /> group
                                                                </div>
                                                                <label className="form-label">Collective QR</label>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>


                                        </center>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-8 col-md-12">
                                        <div className="row">
                                            <div className="col-lg-6 col-md-12">
                                                <div>
                                                    <div className="card card-animate">
                                                        <div className="card-body">
                                                            <div className="d-flex justify-content-between">
                                                                <div>
                                                                    <p className="fw-medium mb-0">{order.fullname}</p>
                                                                    <div>
                                                                        <span className="fw-bold">Order Ref: <Link>{OrderID}</Link></span>
                                                                    </div>
                                                                    <p className="mb-0 text-muted">{order.job_number}</p>
                                                                    <p className="mb-0 text-muted">{vAdminformat.FormatDate(order.date_created)}</p>
                                                                    <span
                                                                        className={`badge ${order.isMould ? "bg-primary" : "bg-secondary"} text-dark d-flex align-items-center gap-1 border text-white`}
                                                                        style={{ fontSize: "0.75rem" }}
                                                                        title={order.isMould ? "Mould" : "Job (STL)"}
                                                                    >
                                                                        <i className={`ri ${order.isMould ? 'ri-coin-line' : ' bx bx-cube'} fs-6`}></i>
                                                                        {order.isMould ? "Mould" : "Job (STL)"}
                                                                    </span>
                                                                </div>
                                                                <div>
                                                                    <div className="avatar-sm flex-shrink-0">
                                                                        <span
                                                                            data-bs-toggle="dropdown"
                                                                            aria-haspopup="true"
                                                                            aria-expanded="false"
                                                                            className={`avatar-title ${order.priority === 1 ? "bg-success" : (order.priority === 2 ? "bg-warning" : (order.priority === 3 ? "bg-danger opacity-50" : "bg-danger"))} rounded-circle fs-2`}
                                                                            role="button"
                                                                        >
                                                                            <i data-feather="users" className="text-light"></i>
                                                                            {order.status_common}
                                                                        </span>
                                                                        <div className="dropdown-menu p-2 shadow rounded border-0">
                                                                            <button
                                                                                className="dropdown-item bg-success text-white mb-2 rounded-lg py-2  px-3 text-center"
                                                                                style={{ transition: "all 0.3s ease", borderRadius: "10px" }}
                                                                                type="button"
                                                                                onClick={() => changePriority(1)}>
                                                                                Normal
                                                                            </button>
                                                                            <button
                                                                                className="dropdown-item bg-warning text-white mb-2 rounded-lg py-2 px-3 text-center"
                                                                                type="button"
                                                                                style={{ transition: "all 0.3s ease", borderRadius: "10px" }}
                                                                                onClick={() => changePriority(2)}>
                                                                                Important
                                                                            </button>
                                                                            <button

                                                                                className="dropdown-item bg-danger opacity-75 text-white mb-2 rounded-lg py-2 px-3 text-center"
                                                                                type="button"
                                                                                style={{ transition: "all 0.3s ease", borderRadius: "10px" }}

                                                                                onClick={() => changePriority(3)}>
                                                                                Moderate
                                                                            </button>
                                                                            <button
                                                                                className="dropdown-item bg-danger text-white rounded-lg py-2 px-3 text-center"
                                                                                type="button"
                                                                                style={{ transition: "all 0.3s ease", borderRadius: "10px" }} onClick={() => changePriority(4)}>
                                                                                Urgent
                                                                            </button>
                                                                        </div>

                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-6">
                                                                <div style={{ height: "200px", width: "100%" }} className="p-2">
                                                                    {/*STL Viewer */}
                                                                    <div
                                                                        className="col-12"
                                                                        style={{ minHeight: "115px", border: '1px solid #dcdcdc' }}
                                                                    >
                                                                        {fileURL && (getFileExtension(fileURL) === "stl" || getFileExtension(fileURL) === "obj") ? (
                                                                            <STLViewer url={fileURL} currentColor={order.materials_color} mystl={true} />
                                                                        ) : (
                                                                            fileURL && (
                                                                                <img src={fileURL} alt="Selected File" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                                                                            )
                                                                        )}
                                                                    </div>


                                                                </div>
                                                            </div>
                                                            <div className="col-6">
                                                                <div className="mt-5">
                                                                    {order.point !== 1 && (
                                                                        <button className="btn btn-warning d-flex align-items-center" onClick={() => {
                                                                            if (order.point === 5) {
                                                                                handleUpdate(4)
                                                                            }
                                                                            if (order.point === 4) {
                                                                                handleUpdate(3)
                                                                            }
                                                                            else if (order.point === 3) {
                                                                                handleUpdate(2)
                                                                            } else if (order.point === 2) {
                                                                                handleUpdate(1)
                                                                            }
                                                                            /*else if (order.point === 4) {
                                                                                handleUpdate(1)
                                                                            }  */

                                                                        }}>
                                                                            <i className="ri-arrow-go-back-line me-2"></i>
                                                                            Send Back
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-6 col-md-12">
                                             {/*    <center>
                                                    <h6 className="text-muted p-2">
                                                        {order.point === 1
                                                            ? "Correct number of waxes delivered?"
                                                            : (order.point === 2
                                                                ? "All items successfully built onto their correct trees?"
                                                                : (order.point === 3
                                                                    ? "All items successfully completed?"
                                                                    : (order.point === 4
                                                                        ? "Ready to finalize Production Sheet and weight?"
                                                                        : "")))}
                                                    </h6>
                                                </center> */}
                                              {/*   <div className="card" style={{ height: "30vh", maxHeight: "30vh", overflowY: "auto" }}>
                                                    <div className="mt-3">
                                                        <div className="table-responsive">
                                                            <table className="table table-borderless align-middle table-nowrap mb-0 table-sm" style={{ lineHeight: '1.9', padding: '0.4rem', height: "30vh", maxHeight: "30vh" }}>

                                                                {order.point > 4 ? (
                                                                    <>
                                                                      
                                                                        <tbody>
                                                                            {[
                                                                                {
                                                                                    question: "Correct number of waxes delivered?",
                                                                                    qty: order.qty,
                                                                                    sp_qty: order.sp1_qty,
                                                                                    pass: order.sp1_pass,
                                                                                },
                                                                                {
                                                                                    question: "All items successfully built onto their correct trees?",
                                                                                    qty: order.qty,
                                                                                    sp_qty: order.sp2_qty,
                                                                                    pass: order.sp2_pass,
                                                                                },
                                                                                {
                                                                                    question: "All items successfully completed?",
                                                                                    qty: order.qty,
                                                                                    sp_qty: order.sp3_qty,
                                                                                    pass: order.sp3_pass,
                                                                                },
                                                                                {
                                                                                    question: "Ready to finalize Production Sheet and weight?",
                                                                                    qty: order.qty,
                                                                                    sp_qty: order.sp4_qty,
                                                                                    pass: order.sp4_pass,
                                                                                },
                                                                            ].map((item, index) => (
                                                                                <React.Fragment key={index}>
                                                                                 
                                                                                    <tr>
                                                                                        <td
                                                                                            className="font-weight-bold"
                                                                                            colSpan={6} //Combine all columns so that all width occupies
                                                                                            style={{ paddingBlock: "26px" }}
                                                                                        >
                                                                                            <h6 className="p-0">{item.question}</h6>
                                                                                        </td>
                                                                                    </tr>

                                                                                  
                                                                                    <tr>
                                                                                        <td className="font-weight-bold" style={{ paddingBlock: "26px" }}>
                                                                                            <h6>{item.qty}</h6>
                                                                                        </td>
                                                                                        <td className="font-weight-bold" style={{ paddingBlock: "26px" }}>
                                                                                            <h6>{item.sp_qty}</h6>
                                                                                        </td>
                                                                                        <td>
                                                                                            <button
                                                                                                style={{ pointerEvents: "none" }} //Disable interactions
                                                                                                type="button"
                                                                                                className={`btn ${item.pass === 1 ? "btn-success" : "btn-outline-success"
                                                                                                    } rounded-circle btn-icon waves-effect waves-light`}
                                                                                            >
                                                                                                Y
                                                                                            </button>
                                                                                        </td>
                                                                                        <td>
                                                                                            <button
                                                                                                style={{ pointerEvents: "none" }} //Disable interactions
                                                                                                type="button"
                                                                                                className={`btn ${item.pass === 0 ? "btn-danger" : "btn-outline-danger"
                                                                                                    } rounded-circle btn-icon waves-effect waves-light`}
                                                                                            >
                                                                                                N
                                                                                            </button>
                                                                                        </td>
                                                                                        <td className="text-center">
                                                                                            <Link
                                                                                                style={{ pointerEvents: "none" }}>
                                                                                                <i
                                                                                                    className={`${item.pass === 1
                                                                                                        ? "ri-checkbox-circle-line text-success"
                                                                                                        : "ri-settings-5-fill text-black"
                                                                                                        }`}
                                                                                                    style={{ fontSize: "25px", verticalAlign: "middle" }}
                                                                                                ></i>
                                                                                            </Link>
                                                                                        </td>
                                                                                    </tr>
                                                                                </React.Fragment>
                                                                            ))}
                                                                        </tbody>

                                                                    </>

                                                                ) : (
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="font-weight-bold" style={{ paddingBlock: "26px" }}>
                                                                                <h6>{order.comment}</h6>
                                                                            </td>
                                                                            <td className="font-weight-bold" style={{ paddingBlock: "26px" }}>
                                                                                <h6>{order.qty}</h6>
                                                                            </td>
                                                                            <td className="font-weight-bold">
                                                                                <div className="dropdown">
                                                                                    <button
                                                                                        className="btn btn-light dropdown-toggle"
                                                                                        type="button"
                                                                                        id={`dropdownMenuButton-${order.point === 1 ? order.sp1_qty : (order.point === 2 ? order.sp2_qty : (order.point === 3 ? order.sp3_qty : (order.point === 4 ? order.sp4_qty : "")))}`}
                                                                                        data-bs-toggle="dropdown"
                                                                                        aria-expanded="false"
                                                                                    >
                                                                                        {order.point === 1 ? order.sp1_qty : (order.point === 2 ? order.sp2_qty : (order.point === 3 ? order.sp3_qty : (order.point === 4 ? order.sp4_qty : "")))}
                                                                                    </button>
                                                                                    <ul className="dropdown-menu" aria-labelledby={`dropdownMenuButton-${order.point === 1 ? order.sp1_qty : (order.point === 2 ? order.sp2_qty : (order.point === 3 ? order.sp3_qty : (order.point === 4 ? order.sp4_qty : "")))}`}>
                                                                                        {Array.from({ length: order.qty + 1 }, (_, i) => (
                                                                                            <li key={i}>
                                                                                                <button className="dropdown-item" onClick={() => handleSelectQuantity(order, i)}>
                                                                                                    {i}
                                                                                                </button>
                                                                                            </li>
                                                                                        ))}
                                                                                    </ul>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <button
                                                                                    type="button"

                                                                                    className={`btn ${order.point === 1 ? (order.sp1_pass === 1 ? "btn-success" : "btn-outline-success") : (order.point === 2 ? (order.sp2_pass === 1 ? "btn-success" : "btn-outline-success") : (order.point === 3 ? (order.sp3_pass === 1 ? "btn-success" : "btn-outline-success") : (order.point === 4 ? (order.sp4_pass === 1 ? "btn-success" : "btn-outline-success") : "")))} rounded-circle btn-icon waves-effect waves-light`}
                                                                                    onClick={() => handleChangePass(order, 1)}
                                                                                >Y</button>
                                                                            </td>
                                                                            <td>
                                                                                <button type="button"

                                                                                    className={`btn ${order.point === 1 ? (order.sp1_pass === 0 ? "btn-danger" : "btn-outline-danger") : (order.point === 2 ? (order.sp2_pass === 0 ? "btn-danger" : "btn-outline-danger") : (order.point === 3 ? (order.sp3_pass === 0 ? "btn-danger" : "btn-outline-danger") : (order.point === 4 ? (order.sp4_pass === 0 ? "btn-danger" : "btn-outline-danger") : "")))} rounded-circle btn-icon waves-effect waves-light`}
                                                                                    onClick={() => handleChangePass(order, 0)}
                                                                                >N</button>
                                                                            </td>
                                                                            <td className="text-center">
                                                                                <span >

                                                                                    <i
                                                                                        className={`${order.point === 5
                                                                                            ? "ri-checkbox-circle-line text-success"
                                                                                            : "ri-settings-5-fill text-black"
                                                                                            }`}
                                                                                        style={{ fontSize: "25px", verticalAlign: "middle" }}
                                                                                    ></i>

                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                )}

                                                            </table>
                                                        </div>

                                                    </div>
                                                </div> */}
                                                <center>
                                                    <p className="fw-medium mb-0">Reprint Qty: {order.print}</p>
                                                </center>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-12 mt-3 mt-lg-0 p-2">
                                        <div className="col-12">

                                            <center>
                                                <div className="row w-100 mx-0 gy-2">

                                                    <div className="col-12">
                                                        <div className="row">
                                                            <div className="col-6">
                                                                <button
                                                                    className="btn btn-warning w-100  rounded d-flex align-items-center justify-content-center"
                                                                    onClick={showAddCommentModal}
                                                                >
                                                                    <i
                                                                        className="ri-reply-line me-2"
                                                                        style={{ fontSize: "1.4rem", lineHeight: "1" }}
                                                                    ></i>
                                                                    Reprint
                                                                </button>
                                                            </div>

                                                            <div className="col-6">
                                                                <button
                                                                    className={`btn ${order.point === 4 || order.point === 5 ? "btn-secondary" : "btn-success"
                                                                        } w-100  rounded d-flex align-items-center justify-content-center`}
                                                                    onClick={() => {
                                                                        if (order.point === 1) {
                                                                            handleUpdate(2);
                                                                        } else if (order.point === 2) {
                                                                            handleUpdate(3);
                                                                        } else if (order.point === 3) {
                                                                            handleUpdate(4);
                                                                        } else if (order.point === 4) {
                                                                            handleUpdate(5);
                                                                        } else if (order.point === 5) {
                                                                            openModalItem();
                                                                        }
                                                                    }}
                                                                >
                                                                    <i
                                                                        className="ri-arrow-right-circle-line me-2"
                                                                        style={{ fontSize: "1.4rem", lineHeight: "1" }}
                                                                    ></i>
                                                                    {order.point === 1
                                                                        ? "SP2"
                                                                        : order.point === 2
                                                                            ? "SP3"
                                                                            : order.point === 3
                                                                                ? "Confirm QC"
                                                                                : order.point === 4
                                                                                    ? "Complete"
                                                                                    : "Send To Xero"}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-12 px-1 p-2">
                                                        <button
                                                            className="btn btn-primary py-3"
                                                            style={{ width: "97%" }}
                                                            onClick={() => handleUpdate(4)}
                                                        >
                                                            <i className="bi bi-upc-scan me-2"></i> Scan Single to QC
                                                        </button>
                                                    </div>

                                                    <div className="col-12 px-1 p-2">
                                                        <button
                                                            className="btn btn-info  py-3 "
                                                            style={{ width: "97%" }}
                                                            onClick={() => {
                                                                if (order.point === 1) {
                                                                    changeGroupCollective(20);
                                                                } else if (order.point === 2) {
                                                                    changeGroupCollective(21);
                                                                } else if (order.point === 3) {
                                                                    changeGroupCollective(22);
                                                                } else if (order.point === 4) {
                                                                    changeGroupCollective(23);
                                                                }
                                                            }}
                                                        >
                                                            <i className="bi bi-collection-fill me-2"></i> Scan Collective Forward
                                                        </button>
                                                    </div>

                                                    <div className="col-12 px-1 p-2">
                                                        <button
                                                            className="btn btn-success  py-3 "
                                                            style={{ width: "97%" }}
                                                            onClick={() => changeGroupCollective(22)}
                                                        >
                                                            <i className="bi bi-check-circle-fill me-2"></i> Scan Collective to QC
                                                        </button>
                                                    </div>
                                                </div>
                                            </center>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                )}


                {/*end row*/}
                {isComment && (
                    <AddLiveJobComment JobID={OrderID} onClose={CloseAddCommentModal} getJobs={getCurrentOrder} isBegin={true} />
                )}
                {isModifiyComment && (
                    <ModifyComment OrderID={OrderID} onCommentID={onCommentID} onClose={CloseModifyCommentModal} getJobs={getTrackingData} />
                )}

                <div>

                    {showPrintableDiv && (
                        <div ref={componentRef} id="printable-area" className="container mt-4 p-4" style={{ width: '500px', padding: '20px' }}>
                            <div className="row">
                                <div className="col-12 mb-4">
                                    <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
                                        <tbody>
                                            <tr>
                                                <td style={{ padding: '4px 8px' }}><strong>Name:</strong></td>
                                                <td style={{ padding: '4px 8px' }}>{Job.fullname}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '4px 8px' }}><strong>Job Number:</strong></td>
                                                <td style={{ padding: '4px 8px' }}>{Job.job_number}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '4px 8px' }}><strong>Date:</strong></td>
                                                <td style={{ padding: '4px 8px' }}>{vAdminformat.FormatDate(Job.date_created)}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '4px 8px' }}><strong>Description:</strong></td>
                                                <td style={{ padding: '4px 8px' }}>{"define"}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '4px 8px' }}><strong>Parts:</strong></td>
                                                <td style={{ padding: '4px 8px' }}>{Job.parts}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '4px 8px' }}><strong>Alloy:</strong></td>
                                                <td style={{ padding: '4px 8px' }}>{Job.materials_name}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div className="col-12">
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="text-center">
                                                {imageURL ? (
                                                    <img src={imageURL} alt="STL Image" style={{ width: '100%', height: '16vh', minWidth: '16vh', border: '1px solid #ccc' }} />
                                                ) : (
                                                    <p>Loading Image...</p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-6" style={{ paddingLeft: '10px' }}>
                                            <div className="row">
                                                <div className="col-6 text-center">
                                                    {Job?.barcode && (
                                                        <QRCode
                                                            size={100}
                                                            value={Job.barcode}
                                                            style={{ marginBottom: '10px' }}
                                                        />
                                                    )}
                                                </div>
                                                <div className="col-6 text-center">
                                                    <h6 style={{ fontSize: '12px', marginTop: '40px' }}>Quick scan group</h6>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-6 text-center">
                                                    {Job?.barcode && (
                                                        <QRCode
                                                            size={100}
                                                            value={Job.barcode}
                                                        />
                                                    )}
                                                </div>
                                                <div className="col-6 text-center">
                                                    <h6 style={{ fontSize: '12px', marginTop: '40px' }}>Single back to Print folder ONLY</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </div>

            <div
                className={`modal fade ${modalItem ? "show" : ""}`}
                style={{
                    display: modalItem ? "block" : "none",
                    backgroundColor: "#0000007a",
                }}
                tabIndex="-1"
            >
                <div className="modal-dialog w-100 h-100 m-0" role="document">
                    <div className="modal-content h-100">
                        <div className="modal-header text-white">
                            <h3 className="modal-title" id="addItemModalLabel">
                                <i className="fas fa-file-invoice"></i> Generate Invoice to Xero
                            </h3>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={closeModalItem}
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body overflow-auto">
                            <div className="card border-0">
                                <div className="card-body">
                                    <h4 className="text-center text-secondary">Product Selection</h4>

                                    <div className="mb-4">
                                        <label className="form-label">Invoice Status in Xero</label>
                                        <select
                                            className="form-select"
                                            value={invoiceStatus}
                                            onChange={(e) => setInvoiceStatus(e.target.value)}
                                        >
                                            {statusOptions.map((status) => (
                                                <option key={status.value} value={status.value}>
                                                    {status.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="table-responsive">
                                        <table className="table table-striped table-sm table-hover align-middle">
                                            <thead>
                                                <tr>
                                                    <th>Select</th>
                                                    <th>Name</th>
                                                    <th>Quantity</th>
                                                    <th>Price</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr style={{ cursor: 'pointer' }}>
                                                    <td></td>
                                                    <td>{order.materials_name}</td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            min="1"
                                                            value={order.qty || 1}
                                                            onChange={(e) => handleQuantityChange(order.pto_ID, parseInt(e.target.value))}
                                                            disabled={!order.isSelected}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            min="0"
                                                            step="0.01"
                                                            value={order.price}
                                                            onChange={(e) => handlePriceChange(order.pto_ID, parseFloat(e.target.value))}
                                                            disabled={!order.isSelected}
                                                        />
                                                    </td>
                                                </tr>
                                                {productList.map((product) => (
                                                    <tr key={product.pto_ID} style={{ cursor: 'pointer' }}>
                                                        <td onClick={() => handleCheckboxChange(product)}>
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                checked={product.isSelected}
                                                                onChange={() => handleCheckboxChange(product)}
                                                            />
                                                        </td>
                                                        <td onClick={() => handleCheckboxChange(product)}>
                                                            <label style={{ cursor: 'pointer' }}>{product.name}</label>
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                min="1"
                                                                defaultValue={1}
                                                                value={product.qty}
                                                                onChange={(e) => handleQuantityChange(product.pto_ID, parseInt(e.target.value))}
                                                                disabled={!product.isSelected}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                min="0"
                                                                step="0.01"
                                                                value={product.price}
                                                                onChange={(e) => handlePriceChange(product.pto_ID, parseFloat(e.target.value))}
                                                                disabled={!product.isSelected}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer d-flex justify-content-between">
                            <button type="button" className="btn btn-secondary" onClick={closeModalItem}>
                                <i className="fas fa-times"></i> Close
                            </button>
                            <button type="button" className="btn btn-success" onClick={createInvoiceXero}>
                                <i className="fas fa-save"></i> Save Changes & Send to Xero
                            </button>
                        </div>
                    </div>
                </div>
            </div>


        </div>

    )
}


export default QRJobViewOnlyJob;